import styled from '@emotion/styled';
import { Drawer, Hidden, withStyles } from '@material-ui/core';
import { Location } from 'history';
import { createElement, FC, Fragment } from 'react';

import AcctAccount from '../../../../entity/AcctAccount';
import Agent from '../../../../entity/Agent';
import BfOrganization from '../../../../entity/BfOrganization';
import Membership from '../../../../entity/Membership';
import Organization from '../../../../entity/Organization';
import theme from '../../../../theme';
import { COLOR_SIDEMENU_BACKGROUND } from '../../../constant/color';
import DrawerContents, { MENU_WIDTH } from './DrawerContents';
import ServiceContents, { LINK_MENU_WIDTH } from './ServiceContents';

interface Props {
  selected: string;
  onSelectMenu: (item: string) => void;
  open: boolean;
  onClose: () => void;
  className?: string;
  profileUrl: string;
  organizations: Organization[] | null;
  setCurrentOrgOrAccount: (organization: Organization) => void;
  currentOrgOrAccount: Organization | null;
  currentAccount: Organization | null;
  currentOrganization: Organization | null;
  currentAcctAccount: AcctAccount | null;
  currentAcctAccountLoading: boolean;
  currentBfOrganization: BfOrganization | null;
  currentBfOrganizationLoading: boolean;
  location: Location<unknown>;
  currentUserId: string;
  memberships?: Membership[];
  currentAgent: Agent | null;
}

const MenuDrawer: FC<Props> = ({
  className,
  onSelectMenu,
  selected,
  open,
  onClose,
  profileUrl,
  organizations,
  setCurrentOrgOrAccount,
  currentOrgOrAccount,
  currentAccount,
  currentOrganization,
  currentAcctAccount,
  currentAcctAccountLoading,
  currentBfOrganization,
  currentBfOrganizationLoading,
  location,
  currentUserId,
  memberships,
  currentAgent,
}) => {
  return location.pathname !== '/questionnaire/kaizen_ad_us' && location.pathname !== '/questionnaire/kaizen_ad_jp' ? (
    <Fragment>
      <Hidden smDown>
        <Static className={className} variant="permanent">
          <ServiceContents />
          <DrawerContents
            selected={selected}
            onSelectMenu={onSelectMenu}
            profileUrl={profileUrl}
            organizations={organizations}
            setCurrentOrgOrAccount={setCurrentOrgOrAccount}
            currentOrgOrAccount={currentOrgOrAccount}
            currentAccount={currentAccount}
            currentOrganization={currentOrganization}
            currentAcctAccount={currentAcctAccount}
            currentAcctAccountLoading={currentAcctAccountLoading}
            currentBfOrganization={currentBfOrganization}
            currentBfOrganizationLoading={currentBfOrganizationLoading}
            currentUserId={currentUserId}
            memberships={memberships}
            currentAgent={currentAgent}
          />
        </Static>
      </Hidden>
      <Hidden mdUp>
        <Triggerable className={className} open={open} onClose={onClose} anchor="top" style={{ zIndex: 1000 }}>
          <Nav>
            <DrawerContents
              selected={selected}
              onSelectMenu={(item: string) => {
                onSelectMenu(item);
                onClose();
              }}
              profileUrl={profileUrl}
              organizations={organizations}
              setCurrentOrgOrAccount={setCurrentOrgOrAccount}
              currentOrgOrAccount={currentOrgOrAccount}
              currentAccount={currentAccount}
              currentOrganization={currentOrganization}
              currentAcctAccount={currentAcctAccount}
              currentAcctAccountLoading={currentAcctAccountLoading}
              currentBfOrganization={currentBfOrganization}
              currentBfOrganizationLoading={currentBfOrganizationLoading}
              isSmartPhone
              currentUserId={currentUserId}
              memberships={memberships}
              currentAgent={currentAgent}
            />
          </Nav>
        </Triggerable>
      </Hidden>
    </Fragment>
  ) : null;
};

const Static = withStyles({
  root: {
    width: `${MENU_WIDTH + LINK_MENU_WIDTH}px`,
    flexShrink: 0,
  },
  paperAnchorDockedLeft: {
    borderRight: 'none',
  },
  paper: {
    flexDirection: 'row',
    backgroundColor: COLOR_SIDEMENU_BACKGROUND,
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
      width: '5px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#eee',
    },
  },
})(Drawer);

const Triggerable = withStyles({
  root: {
    width: '100%',
    flexShrink: 0,
  },
  paper: {
    width: '100%',
    height: '100%',
  },
})(Drawer);

const Nav = styled('nav')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  backgroundColor: theme.palette.common.white,
});

export default MenuDrawer;
